module.exports = __webpack_public_path__ + "img/sygnet.68aa35ab.png";